import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import { OutboundLink } from "gatsby-plugin-google-analytics"
import Button from "../ui/Button"
import Dropdown, { DropdownItem, DropdownHeader } from "../ui/Dropdown"
import Hamburger from "../ui/Hamburger"
import api from "../../core/sdk/networkInterface"
import ZendutyLogoWhite from "../../assets/images/logos/zenduty-white-full-transparent-bg.png"

export default function Header() {
  const [isHamburgerActive, setIsHamburgerActive] = useState(false)
  const [domainName, setDomainName] = useState("")

  function toggleHamburgerMenu() {
    setIsHamburgerActive(!isHamburgerActive)
  }

  function checkLogin() {
    api
      .post("/account/checklogin/")
      .then(response => {
        if (response.success) {
          // console.log("worked")
          setDomainName(response.domain_name)
        } else {
          setDomainName("")
        }
      })
      .catch(error => {
        // Display error message if user input is incorrect
        console.log(error)
        setDomainName("")
      })
  }
  useEffect(() => {
    checkLogin()
  }, [])
  return (
    <header
      style={{ boxShadow: "0 4px 10px rgba(0,0,0,.40)" }}
      className="zenduty-header fixed top-0 left-0 right-0 bg-dark text-light py-4 z-50"
    >
      <nav className="container flex items-center h-full justify-end md:justify-between font-bold ">
        <Link to="/" className="no-style mr-auto md:mr-0">
          <img
            className="h-8"
            src={ZendutyLogoWhite}
            alt="Zenduty Logo White"
          />
        </Link>
        <ul className="hidden md:flex items-center">
          {/* <li className="mx-8">
            <Dropdown left title="Features">
              <FeaturesItems />
            </Dropdown>
          </li> */}
          <li className="hidden lg:block mx-8">
            <ProductLink />
          </li>
          {/* <Dropdown
          nostyle
          center
          className="hidden lg:block mx-8"
          title={
            <span>Solutions</span>
          }
        >
          <DropdownItem>
            <InfraMonitoringLinkLink />
          </DropdownItem>

        </Dropdown> */}
          <li className="hidden lg:block mx-8">
            <DocsLink />
          </li>
          <li>
            <Dropdown
              nostyle
              right
              title={
                <span className="rounded-md shadow-sm">
                  <button
                    type="button"
                    className="inline-flex justify-center w-full px-4 py-2 bg-white leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 transition ease-in-out duration-150"
                    id="options-menu"
                    aria-haspopup="true"
                    aria-expanded="true"
                  >
                    Compare
                    <svg
                      className="-mr-1 ml-2 h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </span>
              }
            >
              <DropdownItem>
                <PDCompareLink />
              </DropdownItem>
              <DropdownItem>
                <OGCompareLink />
              </DropdownItem>
              <DropdownItem>
                <VOCompareLink />
              </DropdownItem>

              {/* <DropdownDivider />

          <FeaturesItems /> */}
            </Dropdown>
          </li>
          <li className="mx-8">
            <BlogLink />
          </li>
          <li className="mx-8">
            <PricingLink />
          </li>
          <li className="mx-8">
            <WhyLink />
          </li>
        </ul>
        <ul className="flex items-center">
          {domainName.length > 0 ? (
            <>
              <li className="mx-2 hidden lg:block mr-12 pt-2">
                <a href="/dashboard/">
                  {domainName.length > 15
                    ? domainName.substring(0, 15) + "..."
                    : domainName}
                </a>
              </li>
              <li className="mx-2 ">
                <Button secondary as={Link} to="/logout/">
                  Log out
                </Button>
              </li>
            </>
          ) : (
            <>
              <li className="mx-2 hidden lg:block">
                <Link to="/login/">Login</Link>
              </li>
              <li className="mx-2 ">
                <Button secondary as={Link} to="/signup/">
                  Sign Up
                </Button>
              </li>
            </>
          )}
        </ul>
        <Dropdown
          nostyle
          right
          className="md:hidden"
          show={isHamburgerActive}
          title={
            <Hamburger
              active={isHamburgerActive}
              onClick={toggleHamburgerMenu}
            />
          }
        >
          <DropdownItem>
            <DocsLink />
          </DropdownItem>
          <DropdownItem>
            <BlogLink />
          </DropdownItem>
          <DropdownItem>
            <PricingLink />
          </DropdownItem>
          <DropdownItem>
            <WhyLink />
          </DropdownItem>

          {/* <DropdownDivider />

          <FeaturesItems /> */}
        </Dropdown>
      </nav>
    </header>
  )
}

const FeaturesItems = () => (
  <>
    <DropdownHeader>For Operations</DropdownHeader>
    <DropdownItem>Visibility</DropdownItem>
    <DropdownItem>Incident Alerting</DropdownItem>
    <DropdownItem>Actionable Alerts</DropdownItem>
    <DropdownItem>On-call Scheduling</DropdownItem>

    <DropdownHeader>For SRE and Developers</DropdownHeader>
    <DropdownItem>Incident Response</DropdownItem>
    <DropdownItem>Task Management</DropdownItem>
    <DropdownItem>Integrated Comms</DropdownItem>

    <DropdownHeader>Integrations</DropdownHeader>
    <DropdownItem>Slack</DropdownItem>
  </>
)
const ProductLink = () => <Link to="/product/">Product</Link>
const InfraMonitoringLinkLink = () => (
  <Link to="/infrastructure-monitoring/">Infrastructure Monitoring</Link>
)
const DocsLink = () => (
  <OutboundLink href="https://docs.zenduty.com/">Docs</OutboundLink>
)
const BlogLink = () => (
  <OutboundLink href="https://blog.zenduty.com/">Blog</OutboundLink>
)
const PricingLink = () => <Link to="/pricing/">Pricing</Link>
const WhyLink = () => (
  <Link to="/why/">
    Why <span className="hidden lg:inline-block">Zenduty</span>
  </Link>
)
const PDCompareLink = () => (
  <Link to="/zenduty-the-best-pagerduty-alternative-compare/">Pagerduty</Link>
)
const OGCompareLink = () => (
  <Link to="/zenduty-the-best-opsgenie-alternative-compare/">Opsgenie</Link>
)
const VOCompareLink = () => (
  <Link to="/zenduty-the-best-victorops-alternative-compare/">VictorOps</Link>
)
